import React, { useState } from 'react';
import {useDispatch} from "react-redux";

import DevicesList from "./DevicesList";
import SearshDevices from "./details/SearshDevices";
import {useEffectAsync} from "./reactHelper";
import {devicesActions, notificationsActions} from "./store";

import { makeStyles, useMediaQuery, useTheme} from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ButtonsHistoryMobile from "./shared/ButtonsHistoryMobile";
import {cyberStyles} from "./cssShared/cyberTheme";

const sharedStyle = {
    background: 'rgba(13, 22, 31, 0.9)', // Deep space glass
    backdropFilter: 'blur(12px)',
    borderRight: '1px solid rgba(0, 242, 255, 0.15)',
    position: 'relative',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
}

const useStyles = makeStyles(theme => ({
    ...cyberStyles(theme),
    drawerPaper: {
        ...sharedStyle,
        [theme.breakpoints.up('sm')]: {width: 350,},
        [theme.breakpoints.down('xs')]: {
            height: 350,
            borderRight: 'none',
            borderTop: '1px solid rgba(0, 242, 255, 0.2)',
            borderRadius: '20px 20px 0 0',
        },
    },
    drawerPaperHide: {
        ...sharedStyle,
        [theme.breakpoints.down('xs')]: {height: 0,},
    },
    list: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(0.5),
    },
    iconsList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: '#00f2ff',
    },
    arrowDown: {
        height: 20,
        background: 'rgba(0, 242, 255, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: '#00f2ff',
    },
    mobileBottomContainer: {
        position: 'fixed',
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 15,
    },
}));

const DevicesDrawer = ({googleMap}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch();

    const [phoneDeviceList, setPhoneDeviceList] = useState(false);
    const [phoneDevicesFiltred, setPhoneDevicesFiltred] = useState([]);
    const [phoneSortBy ,setPhoneSortBy] = useState('');

    useEffectAsync(async () => {
        const response = await fetch('/api/devices?all=true');
        if (response.ok) {
            const res = await response.json();
            dispatch(devicesActions.refresh(res));
        }
    }, []);

    useEffectAsync(async () => {
        const response = await fetch('/api/nots/notificationsWSMore/0');
        if (response.ok) {
            const res = await response.json();
            dispatch(notificationsActions.refreshNotifications(res))
        }
        if (!isDesktop)
            setPhoneDeviceList(true)
    }, []);

    return (
        <>
            {isDesktop ?
                <DevicesList googleMap={googleMap} phoneDeviceList={false}/>
                :
                <>
                    <Drawer
                        anchor='bottom'
                        variant='permanent'
                        classes={{ paper: phoneDeviceList ? classes.drawerPaper : classes.drawerPaperHide }}
                    >
                        <DevicesList googleMap={googleMap} phoneDeviceList={phoneDeviceList} phoneDevicesFiltred={phoneDevicesFiltred} phoneSortBy={phoneSortBy}/>
                    </Drawer>
                    <div className={classes.mobileBottomContainer}>
                        <SearshDevices setDeviceList={setPhoneDeviceList} deviceList={phoneDeviceList} setDevicesFiltred={setPhoneDevicesFiltred}
                                       setSortBy={setPhoneSortBy} sortBy={phoneSortBy}/>
                    </div>
                    {phoneDeviceList && !isDesktop && (
                        <div className={classes.collapseBar} onClick={() => setPhoneDeviceList(false)}>
                            <ExpandMoreIcon style={{ color: '#00f2ff', fontSize: '20px' }} />
                        </div>
                    )}
                    {!phoneDeviceList && <ButtonsHistoryMobile setDevicesList={setPhoneDeviceList}/>}
                </>
            }
        </>
    );
}

export default React.memo(DevicesDrawer);